import { Title } from '@atlas/ui-kit'
import { formatDeadline } from '@/lib/format-date'

export interface StageMarket {
	name: string
	/** Absent for a region, which has no flag. */
	flag: string | null
}

export interface StageHeaderProps {
	/** The order's title; the order code stands in for an order without one. */
	title: string | null
	orderCode: string
	dueAt: string | null
}

/** The order at a glance, as the Full Path screens head it: its title, its code, and when it is due. */
export function StageHeader({ title, orderCode, dueAt }: StageHeaderProps) {
	return (
		<Title
			size="large"
			title={title || orderCode}
			subtitle={orderCode}
			deadline={dueAt ? formatDeadline(dueAt) : undefined}
			// The screens set the pill beside the heading, not at the far end of the row.
			className="mb-6 justify-start gap-16"
		/>
	)
}
